import { Routes } from "@angular/router";
import { UserListComponent } from "./user-list/user-list.component";
import { CreateUserComponent } from "./create-user/create-user.component";
import { EditUserComponent } from "./edit-user/edit-user.component";
import { unsavedChangesGuard } from "../../shared/guards/unsaved-changes.guard";

export const usersRoutes: Routes = [
    {
        path: '',
        component: UserListComponent,
    },
    {
        path: 'create',
        component: CreateUserComponent,
        title: 'Create User',
    },
    {
        path: ':id/edit',
        component: EditUserComponent,
        title: 'Edit User',
        canDeactivate: [unsavedChangesGuard],
    }
];